import { h } from 'hyperapp';
export default (() => h("i", {
  class: "mdui-icon material-icons avatar"
}, "account_circle"));